"use client";

import { useQuery } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

import { fetchCountryCode } from "services/marinade/fetchCountryCode";

export default function LandingPageContent() {
  const router = useRouter();

  // Trying to fetch the country code as early as possible so it will be available in wallet connect modal
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const countryCode = useQuery<string>(
    ["countryCode"],
    () => fetchCountryCode(),
    {
      staleTime: Infinity,
      cacheTime: Infinity,
    }
  );

  useEffect(() => {
    router.push(`/liquidity`);
  }, [router]);

  return null;
}
